import * as roles from "./access/roles";
import * as rolesUtils from "./access/utils";

class ContactPersonSerializer {
    static unserialize(response) {
        let formData = {...response};

        if (response.image && response.image.id) {
            formData.defaultImages = [response.image];
            formData.images = [];
            formData.defaultImageIds = [response.image.id];
        }
        else {
            formData.images = formData.defaultImages = formData.defaultImageIds = [];
        }

        if(response.company) {
            formData.companyId = response.company.id;
        }

        if(response.roles) {
            formData.isAdmin = rolesUtils.rolesHasAccess(response.roles, [roles.FBG_WEBMASTER]);
        }
        else {
            formData.isAdmin = false;
        }

        return formData;
    }
}

export default ContactPersonSerializer;


// WEBPACK FOOTER //
// ./web/src/services/ContactPersonSerializer.js